<template>
  <div class="post-rating" data-testid="screen-post-rating">
    <img v-if="imageUrl" :src="imageUrl" alt="" class="image" data-testid="post-rating-image" />
    <BranchLogo v-else :branch="branch" class="brand" />
    <h1 class="title" data-testid="post-rating-title">{{ title }}</h1>
    <p v-if="content" class="content" data-testid="post-rating-content">{{ content }}</p>
  </div>
</template>

<script>
import BranchLogo from './BranchLogo.vue';
import { scheduleAfter } from './scheduling';

const DEFAULT_TITLE = 'ขอบคุณที่ใช้บริการ';
const DEFAULT_SECONDS = 60;

export default {
  name: 'PostRatingScreen',
  components: { BranchLogo },
  props: {
    branch: { type: Object, default: null }
  },
  computed: {
    title() {
      return (this.branch && this.branch.postRatingTitle) || DEFAULT_TITLE;
    },
    content() {
      return (this.branch && this.branch.postRatingContent) || '';
    },
    imageUrl() {
      return (this.branch && this.branch.postRatingImageUrl) || '';
    }
  },
  mounted() {
    const seconds = (this.branch && this.branch.postRatingDisplaySeconds) || DEFAULT_SECONDS;
    this.customerDisplayCancelTimer = scheduleAfter(seconds * 1000, () => this.$emit('finished'));
  },
  beforeDestroy() {
    if (this.customerDisplayCancelTimer) this.customerDisplayCancelTimer();
  }
};
</script>

<style scoped>
.post-rating {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3vh;
  background: #f5f3ff;
  padding: 4vh 4vw;
  text-align: center;
}
.image {
  max-height: 34vh;
  max-width: 60vw;
  object-fit: contain;
}
.brand ::v-deep .logo {
  max-height: 34vh;
  max-width: 60vw;
}
.title {
  margin: 0;
  font-size: calc(3.5rem * var(--font-scale));
  font-weight: 600;
  color: #4c1d95;
}
.content {
  margin: 0;
  max-width: 70vw;
  font-size: calc(1.4rem * var(--font-scale));
  color: #4b5563;
  overflow-wrap: anywhere;
}
</style>
